import React from 'react';
import {
  Link
} from "react-router-dom";



class Footer extends React.Component{
	constructor(props){
            super(props);
            this.state = {
                uls :[
						{
							title:"Thông tin",
							name:"Giới thiệu",
							name1:"Liên hệ công ty",
							name2:"Đối tác",
						},
						{
							title:"Chính sách",
							name:" Chính sách đổi hàng",
							name1:" Chính sách bảo hành",
							name2:" Chính sách bảo mật"
						},
						{
							title:"FAQ",
							name:"Thanh toán và vận chuyển",
							name1:"Hướng dẫn chọn size",
							name2:"Kiểm tra thông tin đơn hàng",
							name3:"Câu hỏi thường gặp",
						}
					]
    			}
    		}

showUls = (datas) =>{
            var result = null;
                result = datas.slice(0,4).map((ul, index)=>{
                    return ( 
                        <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2" key={index}>
		                    <div className="support">
		                        <ul >
		                            <p>{ul.title}</p>
		                            <hr/>
		                            <li><Link to=""> {ul.name}</Link></li>
		                            <li><Link to="">{ul.name1}</Link></li>
		                            <li><Link to="">{ul.name2}</Link></li>
		                            <li><Link to="">{ul.name3}</Link></li>
		                            <li><Link to="">{ul.name4}</Link></li>
		                        </ul>
		                    </div>
		                </div>
                    )
                })
            return result
    }

	render(){
		const { uls } = this.state;
			return ( 
			   <div className="row custom_row">
	                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
	                    <div className="footer">
	                        <div className="row custom_row">
	                            
	                           {this.showUls(uls)}
	                           	<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
	                           		<div className="support">
		                           		<p>FANPAGE</p>
		                           		<hr/>
		                           		<br/>
		                                <div className="fb-page" data-href="https://www.facebook.com/tabbybong.com.vn/" data-tabs="timeline" data-width="330" data-height="300" scrolling="no" data-testid="fb:page Facebook Social Plugin" frameBorder="0" allowtransparency="true" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true" style={{visibility:"visible"}}><blockquote cite="https://www.facebook.com/tabbybong.com.vn/" class="fb-xfbml-parse-ignore"><Link to="https://www.facebook.com/tabbybong.com.vn/">Tabby Bông</Link></blockquote></div>
		                            </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	    	)
	    }
	}
export default Footer;